export default "__VITE_ASSET__oK_7Hwyp__"